import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} viewBox="0 0 13 10" style={{
    fill: "none"
  }} xmlns="http://www.w3.org/2000/svg"><path d="M11 2L5.5 8 2 4.182" style={{
      strokeWidth: 2.5,
      strokeLinecap: "round"
    }} /></svg>;
}
export default SvgComponent;